import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import config from "../Api/config";
import QrCodeScanner from "./qrCodeScanner";

function Explorer() {
    
  const navigate = useNavigate();
  const [brands, setBrands] = useState<any[]>([]);
  const notifyError = (err:any) => toast.error(err,{theme:"colored"});

    /* Fetch all owners  */
    useEffect(() => {
        // get all products
        config.API.getOwners().then((item) => {
            setBrands( [...item.map((val) => {
                return {
                  value: val.id,
                  label: val.name ,
            }; })]);
        }).catch(error => {
            console.error("Error in get owners API: ",error);
            notifyError("Error in get owners API: " + error);
        });
    }, []);

  const handleChange = (event: any, value: any) => {
    //console.log(brands,event,value);
    if (value !== null) {
      navigate(`/company/${value.value}`);
    }
  };

  const [openQrReader, setOpenQrReader] = useState(false);
  function handleQrClick() {
    setOpenQrReader(!openQrReader);
    //navigate(`/qrcode`);
  }

  function onQrScan(result: string) {
    console.log(result);
  }

  return (
    <div className="explorer">
      {/*<h2>View your product’s specific details</h2>*/}
      <h2 style={{fontSize:"40px", fontWeight:"200", lineHeight:"45px", marginBottom:"5px"}}>Find your digital product passport</h2>
      <p>Select an option</p>
      <QrCodeScanner qrBorderSize="100px" onScanResult={onQrScan} elementsWhenOffline={
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                className="autocomplete-dropdown"
                options={brands}
                renderInput={(params) => (
                    <TextField {...params} label="Select a company" />
                )}
                onChange={handleChange}
                fullWidth={true}
            />
      }/>
    </div>
  );
}
export default Explorer;
